<script setup lang="ts">
import Translate from "addeus-common-library/components/base/translation/Translate.vue";
import type { Speed } from "../../models/race/speed";
import type { SpeedLimitation } from "../../models/owner";
import { computed } from "vue";

interface SpeedTranslateProps {
    speed: Speed;
    override?: SpeedLimitation;
    displayAge?: boolean;
}

const props = withDefaults(defineProps<SpeedTranslateProps>(), { displayAge: false });
const basePath = "speed2max.speeds";
await props.speed.$getMetadata().refresh();
const speedPath = computed(() => {
    return `${basePath}.${
        hasNoOverride() ? props.speed.name : hasNoMaxAge() ? "min" : "range"
    }`;
});
const path = computed(() => `${speedPath.value}.label`);
const values = computed(() => {
    return {
        max: props.override?.maxAge ?? 0,
        min: props.override?.minAge ?? 0,
    };
});

function hasNoOverride(): boolean {
    return props.override === undefined;
}

function hasNoMaxAge(): boolean {
    if (hasNoOverride()) return true;
    return (props.override?.maxAge ?? 0) === 0;
}
</script>

<template>
    <span>
        <Translate :path="`${path}`" />
        <span
            v-if="props.displayAge === true || props.override !== undefined"
            class="is-italic has-text-weight-light ml-2">
            <Translate :path="`${speedPath}.age`" :values="values" />
        </span>
    </span>
</template>
